import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pic from '../assets/images/react-themes-dimension-page.jpg'

const Generic = (props) => (
    <Layout>
        <Helmet>
            <title>React Themes - Dimension</title>
            <meta name="description" content="Dimension - Beautiful React theme crafted by HTML5 Up. Coded in React / GatsbyJS by @AppSeed.us" />
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>React Themes - Dimension</h1>
                    </header>
                    <span className="image main"><img src={pic} alt="React Themes Dimension - Coded in React by AppSeed.us. Designed by HTML5 Up" /></span>
                    <p>
                        <h2>What is React?</h2>
                        Facebook's React, a JavaScript library, is a component based view abstraction. A component could be a form input, button, or any other element in your user interface. This provides an interesting contrast to earlier approaches as React isn't bound to the DOM by design. You can use it to implement mobile applications for example.                    
                    </p>
                    <p>
                        <h2>App features</h2>
                        AppSeed integrates on top of Stellar design some basic features, in order to help developers, especially the beginners:
                        <br /> - Ftp Deploy Script - on top of ftp-deploy npm package 
                        <br /> - Google Analytics module, Sitemap module - provided by GatsbyJS (a React Framework). 
                        <br /> - The code is published on Github, feel free to use it in your future web application.                       
                    </p>
                    <p>
                        <h2>Resources</h2>
                        Live <a target="_blank" without rel="noopener noreferrer" href="https://react-themes-dimension.appseed.us">Demo</a>, 
                        Github <a target="_blank" without rel="noopener noreferrer" href="https://github.com/react-theme/dimension">Sources</a>.
                        <br />
                        Read more about <a target="_blank" rel="noopener noreferrer" href="https://blog.appseed.us/react-themes-dashboards-landing-pages/">React Themes</a> on our blog or 
                        {' '}<a target="_blank" rel="noopener noreferrer" href="https://appseed.us?ref=react-themes">Generate a React App</a> in a few minutes (no account needed).   
                    </p>
                </div>
            </section>
        </div>

    </Layout>
)

export default Generic